export const videoAttributesDictionary = {
    beginDateTime: {
        header: "Beginning time",
        visible: true,
        renderType: "datetime"
    },
    createdByUserId: {
        header: "Created by (id)",
        visible: false,
        renderType: "text"
    },
    createdByUserName: {
        header: "Created by (name)",
        visible: true,
        renderType: "text"
    },
    createdDateTime: {
        header: "Created on",
        visible: true,
        renderType: "datetime"
    },
    duration: {
        header: "Duration",
        visible: true,
        renderType: "numeric",
        unit: 's',
    },
    fileName: {
        header: "File name",
        visible: true,
        renderType: "text"
    },
    projectId: {
        header: "Project Id",
        visible: false,
        renderType: "text"
    },
    id: {
        header: "Movie Id",
        visible: false,
        renderType: "text"
    },
    modifiedByUserName: {
        header: "Modified by",
        visible: true,
        renderType: "text"
    },
    modifiedDateTime: {
        header: "Modified on",
        visible: true,
        renderType: "datetime"
    },
    fileStatus: {
        header: "File status",
        visible: false,
        renderType: "text",
    },
    workspaceId: {
        header: "Project id",
        visible: false,
        renderType: "text",
    },
    faultVideos: {
        header: 'Fault videos',
        visible: false,
        renderType: 'text',
    },
    geomWkt: {
        header: 'Geometry',
        isEditable: false,
        renderType: 'text',
        visible: false,
    },
    faultsCount: {
        header: 'Faults count',
        visible: false,
        renderType: 'text',
    },
}


// WEBPACK FOOTER //
// ./src/utilities/videoDictionary.js